// export const urlAdmin = 'https://api.nets.tj/api/'
export const  urlAdmin = 'http://45.94.219.6:12345/api/'